import { render, staticRenderFns } from "./EmployeeAdvanceItemDetail.vue?vue&type=template&id=97f86778&"
import script from "./EmployeeAdvanceItemDetail.vue?vue&type=script&lang=js&"
export * from "./EmployeeAdvanceItemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports